<template>
  <div class="page page-research">
    <div class="page__wrap" data-animate="page-wrap">
      <PagesCompanyHeader :company="research" />
      <!-- Editorial -->
      <div
        class="p-top-3 p-bot-3"
        data-animate="page-content"
        v-if="research?.editorialContent?.length"
      >
        <LazyEditorialList :content="research.editorialContent" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

// Importa le query GraphQL
import queries from '@/graphql/craft/queries/index.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/company.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el, done)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

const { configuration } = useCraftStore()

// Fetch Data
const query = queries.company.getResearch

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.researchEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const research = computed(() => data.value.researchEntries?.[0])
const seo = computed(() => data.value?.researchEntries?.[0]?.seo || {})

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>

<style></style>
